<template>
  <div>
    <b-row>

      <b-col
          md="12"
          xl="12"
          class="mb-1"
      >
        <b-card-code title="Accountinformationen">

          <b-row>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Username"
              >
                <b-form-input
                    v-model="user.Username"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Name"
              >
                <b-form-input
                    v-model="user.Contact.Name"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="2"
                xl="2"
            >
              <b-form-group
                  label="Typ"
              >
                <b-form-select
                    id="perPageSelect"
                    v-model="user.UserType"
                    :options="TypeOptions"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="2"
                xl="2"
            >
              <b-form-group
                  label="Typ"
              >
                <b-form-select
                    id="perPageSelect"
                    v-model="user.PushoverId"
                    :options="pushoverList"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-code>

        <b-card-code title="Adressinformationen">
          <b-row>
            <b-col
                md="6"
                xl="6"
            >
              <b-form-group
                  label="Straße"
              >
                <b-form-input
                    v-model="user.Address.Street"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="3"
                xl="3"
            >
              <b-form-group
                  label="Postleitzahl"
              >
                <b-form-input
                    v-model="user.Address.ZipCode"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="3"
                xl="3"
            >
              <b-form-group
                  label="Ort"
              >
                <b-form-input
                    v-model="user.Address.Location"
                />
              </b-form-group>
            </b-col>
          </b-row>

        </b-card-code>

        <b-card-code title="Kontaktinformationen">
          <b-row>
            <b-col
                md="3"
                xl="3"
            >
              <b-form-group
                  label="Telefon"
              >
                <b-form-input
                    v-model="user.Contact.Phone"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="3"
                xl="3"
            >
              <b-form-group
                  label="Telefon2"
              >
                <b-form-input
                    v-model="user.Contact.Phone2"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="3"
                xl="3"
            >
              <b-form-group
                  label="Fax"
              >
                <b-form-input
                    v-model="user.Contact.Fax"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="3"
                xl="3"
            >
              <b-form-group
                  label="E-Mail"
              >
                <b-form-input
                    v-model="user.Contact.Email"
                />
              </b-form-group>
            </b-col>
          </b-row>


        </b-card-code>
      </b-col>

      <b-col cols="12">
        <b-card-code>
          <v-select
              v-model="selectedCustomer"
              label="title"
              :options="TaCustomerList"
              class="col-6 float-left mb-2"
          />
          <b-button
              class="col-2 float-right mb-2"
              variant="info"
              size="sm"
              @click="AddAccessCustomer()"
              v-show="hasIdentId && user.UserType == 1"
          >
            <feather-icon
                icon="PlusCircleIcon"
                size="15"
                class="mr-1"
            />
            Neuen Zugriff
          </b-button>
          <b-table
              striped
              hover
              responsive
              :items="items"
              :fields="fields"
              v-show="hasIdentId && user.UserType == 0"
          >

            <template #cell(Access)="row">
              <b-form-checkbox
                  v-model="row.item.Access"
                  class="custom-control-primary"
              >
              </b-form-checkbox>
            </template>
          </b-table>

          <b-table
              striped
              hover
              responsive
              :items="TaAccessList"
              :fields="TaAccessListFields"
              v-show="hasIdentId && user.UserType == 1"
          >

            <template #cell(Action)="row">
              <feather-icon
                  size="16"
                  icon="Trash2Icon"
                  class="mr-50"
                  @click="RemoveAccessCustomer(row)"
              />
            </template>
          </b-table>
        </b-card-code>
      </b-col>
      <b-col
          cols="12"
      >
        <b-card-code>
          <b-button
              class="col-2"
              variant="warning"
              @click="ResetPassword()"
              v-show="hasIdentId"
          >
            <span v-show="!loading"> Passwort zurücksetzen  </span>
            <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
            <div
                v-show="loading"
                class="spinner-border spinner-border-sm"
                role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </b-button>

          <b-button
              class="col-1 ml-2"
              variant="danger"
              @click="Ban()"
              v-show="(user.Locked == false) && hasIdentId"
          >
            <span v-show="!loading"> Sperren  </span>
            <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
            <div
                v-show="loading"
                class="spinner-border spinner-border-sm"
                role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </b-button>

          <b-button
              class="col-1 ml-2"
              variant="danger"
              @click="Ban()"
              v-show="(user.Locked == true) && hasIdentId"
          >
            <span v-show="!loading"> Entsperren  </span>
            <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
            <div
                v-show="loading"
                class="spinner-border spinner-border-sm"
                role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </b-button>
          <b-button
              class="col-4 float-right"
              variant="info"
              @click="Save()"
          >
            <span v-show="!loading"> Speichern  </span>
            <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
            <div
                v-show="loading"
                class="spinner-border spinner-border-sm"
                role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </b-button>
        </b-card-code>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import {
  BTable, BRow, BCol, BFormGroup, BFormSelect, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown, BDropdownItem, BFormCheckbox
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import BCardCode from '@core/components/b-card-code'

export default {
  name: 'user',
  components: {
    vSelect,
    BCardCode,
    BDropdown,
    BDropdownItem,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selectedCustomer: 0,
      hasIdentId: false,
      loading: false,
      lastClickedRow: -1,
      TypeOptions: [{
        value: 1,
        text: 'TravelAgency'
      }, {
        value: 0,
        text: 'Administrator'
      }],
      user: {
        UserId: 0,
        Locked: false,
        Username: '',
        UserType: 1,
        PushoverId: 0,
        Address: {
          Street: '',
          ZipCode: '',
          Location: '',
          District: null
        },
        Contact: {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: ''
        },
        Rights: [],
        GoogleId: 0,
        Customer: [],

      },
      pushoverList: [],
      TaCustomerList: [],
      TaAccessList: [],
      TaAccessListFields: [
        {
          key: 'CustomerNumber',
          label: 'Kundennummer',
        },
        {
          key: 'Name',
          label: 'Name',
        },
        {
          key: 'Location',
          label: 'Ort',
        },
        {
          key: 'Action',
          label: '',
        },
      ],
      fields: [
        {
          key: 'Access',
          label: 'Zugriff',
        },
        {
          key: 'IdentId',
          label: 'RechtId',
        },
        {
          key: 'Name',
          label: 'Name',
        },
        {
          key: 'Description',
          label: 'Beschreibung',
        },
      ],
      items: [],
    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      document.title = 'Neuer Benutzer'
    })
    this.LoadPushoverList();
    this.Load()
  },
  methods: {
    LoadPushoverList() {
      this.pushoverList.push({
        value: 0,
        text: "Kein Account"
      })
      this.$http.get(`/pushover/list`)
          .then(resp => {
            resp.data.list.forEach(p => {
              console.log(p)
              this.pushoverList.push({
                value: p.IdentId,
                text: p.Name
              })
            })

          })
          .catch(err => {
            console.error(err)
          })
    },
    ResetPassword() {
      this.$http.post(('/api/user/password/reset'), JSON.stringify({
        IdentId: this.user.UserId
      }))
          .then(resp => {
            if (resp.data.success) {

              this.$swal({
                icon: 'success',
                title: 'Passwort',
                text: 'Passwort wurde zurückgesetzt. Benutzer erhält Zugangsdaten per E-Mail.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })

            }
          })
          .catch(err => {
            console.error(err)
          })

    },
    Ban() {
      this.$http.post((this.user.Locked ? 'api/user/unlock' : 'api/user/lock'), JSON.stringify({
        UserId: this.user.UserId
      }))
          .then(resp => {
            if (resp.data.success) {
              this.user.Locked = resp.data.state
              this.$swal({
                icon: 'success',
                title: this.user.Locked ? 'Gesperrt!' : 'Entsperrt',
                text: this.user.Locked ? 'Benutzer (' + this.user.Username + ') wurde gesperrt' : 'Benutzer (' + this.user.Username + ') wurde entsperrt',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })

    },
    Add() {
      this.loading = true
      this.items.forEach(i => {
        this.user.Rights[i.IdentId] = i.Access
      })
      this.$http.post('/api/user/create', JSON.stringify(this.user))
          .then(resp => {
            if (resp.data.success) {
              this.loading = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Benutzer wurde gespeichert.',
                  variant: 'success',
                },
              })
            } else {
              this.loading = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: resp.data.errorMessage,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    Save() {
      if (!this.hasIdentId) {
        this.Add()
        return
      }
      this.loading = true
      this.user.RightsObj = []
      this.items.forEach(i => {
        this.user.RightsObj.push({
          IdentId: i.IdentId,
          Access: i.Access
        })
      })
      this.user.Customer = []
      if (this.TaAccessList != null) {
        this.TaAccessList.forEach(i => {
          console.log(i)
          this.user.Customer.push(i.IdentId)
        })
      }
      this.$http.post('/api/user/edit', JSON.stringify(this.user))
          .then(resp => {
            if (resp.data.success) {
              this.loading = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Benutzer wurde gespeichert.',
                  variant: 'success',
                },
              })
            } else {
              this.loading = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: resp.data.errorMessage,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    AddAccessCustomer() {
      this.TaAccessList.push(this.selectedCustomer.listData)
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Hinweis',
          icon: 'CheckIcon',
          text: 'änderung muss gespeichert werden.',
          variant: 'info',
        },
      }, { position: 'bottom-center' })
    },
    RemoveAccessCustomer(row) {
      this.TaAccessList.splice(row.index, 1)

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Hinweis',
          icon: 'CheckIcon',
          text: 'änderung muss gespeichert werden.',
          variant: 'info',
        },
      }, { position: 'bottom-center' })
    },
    Load() {
      console.log(this.edit)
      if (this.$route.params.id != undefined && this.$route.params.id != 'add') {
        this.hasIdentId = true

        this.items = []
        let url = `/api/user/${this.$route.params.id}`
        this.$http.get(url)
            .then(resp => {
              this.user = resp.data.user
              console.log(this.Customer)
              resp.data.rightList.forEach(i => {
                if (resp.data.user.Rights == undefined) {
                  resp.data.user.Rights = []
                }

                if (resp.data.user.Rights[parseInt(i.Value.IdentId)] == undefined) {
                  resp.data.user.Rights[parseInt(i.Value.IdentId)] = false
                }

                this.TaAccessList = resp.data.Customer

                this.items.push({
                  Access: resp.data.user.Rights[parseInt(i.Value.IdentId)],
                  IdentId: i.Value.IdentId,
                  Name: i.Value.Name,
                  Description: i.Value.Description,
                })
              })
            })
            .catch(err => {
              console.error(err)
            })

        this.$http.get('/customer/list/small')
            .then(resp => {
              resp.data.list.forEach(i => {
                this.TaCustomerList.push({
                  key: i.Number,
                  title: i.Number + ' ' + i.Name + ' (' + i.Location + ')',
                  listData: {
                    IdentId: i.IdentId,
                    CustomerNumber: i.Number,
                    Name: i.Name,
                    Location: i.Location,
                  }
                })
              })
            })
            .catch(err => {
              console.error(err)
            })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
